import { IContactTemp } from "./contact-temp";

export interface IGalaContactsListResponse {
    data: {
        success: boolean;
        message: string;
        results: IContactTemp[]
    }
}